<template>
  <div id="ReadClockCard_main">
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      center
    >
      <div class="img" />
      <h2>請感應門禁卡...</h2>
      <input
        v-model="hideData_account"
        type="text"
        name="user"
      ><!-- 不會使用 -->
      <input
        v-model="hideData_password"
        type="password"
        name="user"
      ><!-- 不會使用 -->
      <input
        ref="inputCode"
        v-model="code"
        type="password"
        autocomplete="off"
        @keyup.enter="sandCode"
        @keyup="keyup"
        @blur="onblur"
      >
      <el-button
        type="primary"
        class="householdSwitch"
        round
        @click="disposable"
      >
        一次性打卡
      </el-button>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      iskeyupStarted: false,
      canSandCode: true,
      code: '',
      hideData_account: '', // 不會使用，騙chrome自動帶入帳號欄位
      hideData_password: '' // 不會使用，騙chrome自動帶入密碼欄位
    }
  },
  methods: {
    openDialog () {
      this.dialogVisible = true
      this.init()
      this.$nextTick(() => {
        this.$refs.inputCode.focus()
      })
    },
    sandCode () {
      if (this.code.length < 5) {
        this.$alert('載具格式錯誤，請再次感應卡片', '警告', {
          confirmButtonText: '確認',
          type: 'warning',
          callback: action => {
            this.init()
          }
        })
      } else if (!this.canSandCode) {
        this.$alert('感應失敗，請再次感應卡片', '警告', {
          confirmButtonText: '確認',
          type: 'warning',
          closeOnClickModal: false,
          callback: action => {
            this.init()
          }
        })
      } else {
        this.$emit('sandClockCard', this.code)
        this.close()
      }
    },
    disposable () {
      this.$emit('disposable')
      this.close()
    },
    onblur () {
      if (this.dialogVisible) {
        this.$nextTick(() => {
          this.$refs.inputCode.focus()
        })
      }
    },
    close () {
      this.dialogVisible = false
      this.init()
    },
    keyup () {
      if (!this.iskeyupStarted) {
        this.canSandCode = true
        this.iskeyupStarted = true
        setTimeout(() => {
          this.canSandCode = false
        }, 1000)
      }
    },
    init () {
      this.code = ''
      this.iskeyupStarted = false
      this.canSandCode = true
      this.sandData = false
    }
  }
}
</script>
<style lang="sass" scoped>
#ReadClockCard_main
  h2
    font-weight: bold
    font-size: 30px
    margin: 20px 0 40px 0
    color: $mainFontColor
    text-align: center
  .img
    width: 200px
    height: 200px
    background-size: contain
    background-position: center center
    background-repeat: no-repeat
    margin: 25px auto 20px
    background-image: url('../../../assets/img/NFC/nfg_card.gif')
  .el-button
    float: right
    position: relative
    top: -25px
    margin-right: 10px
  input
    opacity: 0
    width: 1px
</style>
